<script>
import * as EVENT from 'constants/event';

import LayoutSetAbstract from 'components/ui/layout-set/abstract/abstract-layout-set-details';

import SidebarLinkOverlayUsermenu from 'components/ui/menu/persons/sidebar-link-overlay-usermenu';

import NuttremaMenuList from 'components/ui/navigation/nuttrema-menu-list';
import NuttremaMenuListItem from 'components/ui/navigation/nuttrema-menu-list-item';

import PageHelp from 'components/pages/professional/shared/help/page-help-overlay';
import PageMakeCopy from 'components/pages/professional/stuff-to-eat/shared/make-copy/page-make-copy';


export default {
  name: 'layout-set-stuff-to-eat-abstract',
  componentName: 'LayoutSetStuffToEat',
  mixins: [LayoutSetAbstract],
  components: {
    NuttremaMenuList,
    NuttremaMenuListItem,
    SidebarLinkOverlayUsermenu,
    PageHelp,
    PageMakeCopy,
  },
  data() {
    return {
      show: {
        pageHelp: false,
        pageMakeCopy: false,
      },
    };
  },
  methods: {
    fetchDetails() {
      this.$store.dispatch('GetStuffToEatDetails', { type: this.type, id: this.id });
    },
    clearDetails() {
      this.$store.dispatch('ClearStuffToEatDetails', { id: this.id });
    },
  },
  computed: {
    StuffToEatDetails() {
      return this.$store.getters.StuffToEatDetails(this.id);
    },
  },
  created() {
    this.$on(EVENT.SHOW_PAGE_HELP, () => {
      console.log('SHOW_PAGE_HELP');
      this.show.pageHelp = true;
    });

    this.$on(EVENT.SHOW_PAGE_MAKE_COPY, () => {
      console.log('SHOW_PAGE_MAKE_COPY');
      this.show.pageMakeCopy = true;
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/layout-set/stuff-to-eat/layout-set-stuff-to-eat-abstract.vue